import React from "react";
import { View, Text, StyleSheet } from "react-native";
import FoldersIcon from "../Icons/FolderIcon";
import FileItem from "./FileItem";
import { useTheme, AppTheme } from "../theme/colors";
import { FileData } from "../screens/WalletScreen/WalletScreen";

interface FolderAndFilesListingProps {
  folder: string;
  files: FileData[];
  handleFilePress: (file: FileData) => void;
  handleEditFileTitle: (fileId: string, fileTitle: string) => void;
  handleDeleteFile: (id: FileData) => void;
}

const FolderAndFilesListing: React.FC<FolderAndFilesListingProps> = ({
  folder,
  files,
  handleFilePress,
  handleEditFileTitle,
  handleDeleteFile,
}) => {
  const theme = useTheme();
  const folderStyles = getStyles(theme);

  return (
    <View style={folderStyles.folderContainer}>
      <View style={folderStyles.folderInfo}>
        <FoldersIcon width={30} height={30} />
        <Text style={folderStyles.folderName}>{folder}</Text>
      </View>
      <View style={folderStyles.fileList}>
        {files.map((file: FileData, idx: number) => (
          <FileItem
            key={idx}
            file={file}
            handleFilePress={handleFilePress}
            handleEditFileTitle={handleEditFileTitle}
            handleDeleteFile={handleDeleteFile}
          />
        ))}
      </View>
    </View>
  );
};

export default FolderAndFilesListing;

const getStyles = (theme: AppTheme) =>
  StyleSheet.create({
    folderContainer: {
      marginBottom: 20,
    },
    folderInfo: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 10,
    },
    folderName: {
      fontSize: 18,
      fontWeight: "bold",
      marginLeft: 10,
    },
    fileList: {
      marginLeft: 30,
    },
  });
